import { ROUTER_PATHS } from "@/shared";
import { useFetchGetPreagendamientoPymesById } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { Navigate, useParams } from "react-router-dom";
import SaveSolicitudTecnicoPymes from "../../shared/componente/save_solicitud_tecnico_pymes/SaveSolicitudTecnicoPymes";

export default function EditSolicitudTecnicoPlantaExternaPage() {
  const { id } = useParams();

  const { data, isLoading } = useFetchGetPreagendamientoPymesById(id!);

  if (isLoading) return <LoaderComponent />;

  if (!data)
    return (
      <Navigate
        to={ROUTER_PATHS.mantenimientoOperaciones.solicitudTecnicoPymesNav}
      />
    );

  return (
    <SaveSolicitudTecnicoPymes
      preagendamiento={data?.data}
      title="Solicitud Técnico Planta Externa"
      router_path={
        ROUTER_PATHS.mantenimientoOperaciones.solicitudTecnicoPymesNav
      }
      es_corporativo={false}
    />
  );
}
